class HandRaiseService {
    constructor(
        $rootScope,
        logService,
        subscriptionService,
        handRaiseStateService,
        socketService,
        attendeeListService,
        localizationService,
        notificationService,
        growlService
    ) {
        this.$rootScope = $rootScope;
        this.logger = logService.createLoggerWithSource('handRaiseService');
        this.subscriptionService = subscriptionService;
        this.handRaiseStateService = handRaiseStateService;
        this.socketService = socketService;
        this.attendeeListService = attendeeListService;
        this.localizationService = localizationService;
        this.notificationService = notificationService;
        this.growlService = growlService;

        this.handRaiseAvailable = false;

        /** @type {Map<number, number>} */
        this.raisedHands = new Map();

        this.rootSubscription = this.subscriptionService.createSubscription();
        this.subscribeToState();

        this.$rootScope.$on('$destroy', this.onScopeDestroyed.bind(this));
        this.$rootScope.$on('raised-hands-updated', this.onRaisedHandsUpdated.bind(this));
        this.$rootScope.$on('hand-raised', this.onHandRaised.bind(this));
        this.$rootScope.$on('hand-lowered-by-host', this.onHandLoweredByHost.bind(this));
        this.$rootScope.$on('node-reconnected', this.onNodeReconnected.bind(this));
    }

    onScopeDestroyed() {
        this.subscriptionService.endSubscription(this.rootSubscription);
    }

    subscribeToState() {
        this.rootSubscription.add(
            this.handRaiseStateService.handRaiseAvailable$.subscribe(next => {
                this.handRaiseAvailable = next;
            })
        );

        this.rootSubscription.add(
            this.handRaiseStateService.raisedHands$.subscribe(next => {
                this.raisedHands = next;
            })
        );
    }

    getRaisedHands() {
        return this.raisedHands;
    }

    getHandRaiseAvailable() {
        return this.handRaiseAvailable;
    }

    /**
     * @param value {boolean}
     */
    setHandRaiseAvailable(value) {
        this.logger.debug('setHandRaiseAvailable', `value=${value}`);
        this.handRaiseStateService.handRaiseAvailable = value;
        // we request raised hands after got initial-payload
        this.requestRaisedHands();
    }

    /**
     * @param e
     * @param data {{raisedHands: number[]}}
     */
    onRaisedHandsUpdated(e, data) {
        this.handRaiseStateService.raisedHands = data.raisedHands;
    }

    /**
     * @param e
     * @param data {{attendantId: number}}
     */
    onHandRaised(e, data) {
        if (!data || !data.attendantId) {
            return;
        }

        const handRaisedAttendee = this.attendeeListService.findAttendee(data.attendantId);
        if (!handRaisedAttendee) {
            return;
        }

        var notificationMessage = this.localizationService.translate('HAND_RAISE.USER_RAISED_HAND', {
            name: handRaisedAttendee.screenName
        });

        this.notificationService.tryShowDesktopNotification(notificationMessage);
    }

    /**
     * @param e
     * @param data
     */
    onHandLoweredByHost(e, data) {
        var notificationMessage = this.localizationService.translate('HAND_RAISE.HOST_LOWERED_HAND');

        this.growlService.show(notificationMessage, 'success');
        this.notificationService.tryShowDesktopNotification(notificationMessage);
    }

    /**
     * @param attendantId {number}
     */
    raiseHand(attendantId) {
        this.handRaiseStateService.addSubmitting(attendantId);
        this.socketService.send({
            message: 'raise-hand',
            callback: () => {
                this.handRaiseStateService.removeSubmitting(attendantId);
            }
        });
    }

    /**
     * @param attendantId {number}
     */
    lowerHand(attendantId) {
        this.handRaiseStateService.addSubmitting(attendantId);
        this.socketService.send({
            message: 'lower-hand',
            callback: () => {
                this.handRaiseStateService.removeSubmitting(attendantId);
            }
        });
    }

    /**
     * @param attendantId {number}
     */
    lowerAttendeeHand(attendantId) {
        this.handRaiseStateService.addSubmitting(attendantId);
        this.socketService.send({
            message: 'host-lower-hand',
            data: {
                attendantId
            },
            callback: () => {
                this.handRaiseStateService.removeSubmitting(attendantId);
            }
        });
    }

    isHandRaised(attendantId) {
        return this.raisedHands.has(attendantId);
    }

    requestRaisedHands() {
        if (this.handRaiseAvailable) {
            this.socketService.send({
                message: 'request-raised-hands'
            });
        }
    }

    onNodeReconnected() {
        this.handRaiseStateService.submittingAttendantIds = [];
        this.requestRaisedHands();
    }
}

firebird.factory('handRaiseService', [
    '$rootScope',
    'logService',
    'subscriptionService',
    'handRaiseStateService',
    'socketService',
    'attendeeListService',
    'localizationService',
    'notificationService',
    'growlService',
    (...deps) => new HandRaiseService(...deps)
]);
